import React from 'react'
import FuboFreeTemplate from 'src/components/template/fubofree'
import { videos } from 'src/constants/videos'
import { useIsRSNAvailable } from 'src/modules/hooks/useIsRSNAvailable'
import { PlanTypes } from 'src/constants/standaloneData'
import { usPlanData } from 'src/constants/planData/usPlanData'
export default (props) => {
  const { isAvailable } = useIsRSNAvailable(PlanTypes.MASN_PLUS)

  return (
    <FuboFreeTemplate
      location={props.location}
      lang="en"
      market="us"
      video={videos.masn.videoUrl}
      staticAnnotation={videos.masn.staticAnnotation}
      title="Watch MASN+ with Fubo"
      subtitle="Stream Nationals and Orioles games plus more"
      networkSet="baseball"
      customNetworks={['masn']}
      additionalFAQs={additionalFAQs}
      hasPlanCards={isAvailable}
      plans={[usPlanData.masn_plus_network_monthly, usPlanData.pro_standalone_monthly]}
      plansSharedData={{
        teams: usPlanData.masn_plus_network_monthly.teams,
      }}
      disableFreeTrial={true}
    />
  )
}

const additionalFAQs = [
  {
    question: 'Can I watch the Baltimore Orioles on Fubo?',
    answer:
      'Yes, you can watch the Baltimore Orioles on Fubo with MASN+, which provides live coverage of their games.',
  },
  {
    question: 'Can I watch the Washington Nationals on Fubo?',
    answer:
      'Yes, the Washington Nationals are available to watch on Fubo via MASN+, ensuring you can catch their live games and events.',
  },
  {
    question: 'Is there commentary and analysis for MLB games on Fubo?',
    answer: 'Yes, MASN+ includes all Orioles Xtra and Nationals Xtra pregame and postgame shows.',
  },
  {
    question: 'Can I watch highlights and replays of Orioles and Nationals games on Fubo?',
    answer:
      'Yes, Fubo provides access to highlights and replays of Orioles and Nationals games through MASN+, allowing you to catch up on any action you may have missed.',
  },
  {
    question: 'What channels can I watch MLB games on Fubo?',
    answer:
      'You can watch MLB games with Fubo on MASN and MASN 2 when you subscribe to MASN+, which broadcasts games for both the Baltimore Orioles and Washington Nationals.',
  },
  {
    question: 'How do I search for specific Orioles or Nationals games on Fubo?',
    answer:
      "To search for specific Orioles or Nationals games on Fubo, use the search function in the app or website and enter the team name or game date to quickly find the content you're looking for.",
  },
  {
    question: 'Are there any special shows related to MLB on Fubo?',
    answer:
      'Yes, when you subscribe to MASN+ with Fubo you will have access to all Orioles Xtra and Nationals Xtra pregame and postgame shows for analysis and in-depth coverage of the Baltimore Orioles and Washington Nationals.',
  },
]
